import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"
import { API_CONFIG } from "@/shared/config/api-config"
import { IFormData } from "../types/formData"

export const API_URL = `${API_CONFIG.baseURL}/api`

class ApiInstance {
	private axios: AxiosInstance

	constructor() {
		this.axios = axios.create({
			baseURL: API_CONFIG.baseURL,
			timeout: 120000,
			headers: {
				"Content-Type": "application/json",
			},
		})

		this.axios.interceptors.response.use(
			response => response,
			error => {
				if (error?.response?.status === 404) {
					console.error("API 404 Error:", {
						url: error?.config?.url,
						method: error?.config?.method,
						params: error?.config?.params,
					})
				}
				return Promise.reject(error)
			}
		)
	}

	async get<T>(endpoint: string, options: AxiosRequestConfig = {}): Promise<T> {
		const response: AxiosResponse<T> = await this.axios.get(endpoint, options)
		return response.data
	}

	async post<T>(endpoint: string, data: IFormData, options: AxiosRequestConfig = {}): Promise<T> {
		const response: AxiosResponse<T> = await this.axios.post(endpoint, data, options)
		return response.data
	}
}

export const apiInstance = new ApiInstance()
